import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async update ({ state, dispatch }) {
    try {
      const data = {
        first_name: state.firstName,
        last_name: state.lastName,
        email: state.email,
        locale: 'ja-JP',
        timezone: 'Asia/Tokyo'
      }

      if (state.password !== '') {
        data.password = state.password
      }

      await directus.updateUser(state.id, data)
      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
